import React from "react";
import { pure } from "recompose";

import Goal from "./Goal";

const PDGoals = pure(({ unaccepted_decisions }) => (
  <Goal
    name="Product Management"
    checked={unaccepted_decisions.PD === 0 ? true : null}
  />
));

export default PDGoals;



// WEBPACK FOOTER //
// ./src/components/dashboard/PDGoals.js